import React from "react";
import Signup from "../components/AuthComponents/Signup"; // Adjust the path if necessary
import "../styles/SignUp.scss";

 
const SignupPage = () => {
  return (
    <div className="signup-page">
      <div className="signup-page__container">
        <Signup />
      </div>
    </div>
  );
};

export default SignupPage;
